import React, { useEffect, useRef, useState } from "react";
import { Styles } from "./styles";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../api_Routes";
import { useParams } from "react-router-dom";
import { Button, CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import UserPhoto from "../../../../Assets/userphoto.png";
import IncomingUserPhoto from "../../../../Assets/Dashbaord/chat/userImage.svg";
// import { pusher } from "../../../../tools/pusher";
import { useNotifications } from "../../../../Context/notificationContext";

const ChatComponent = ({
  status,
  data,
  getData,
  isSendLoading,
  setIsSendLoading,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();
  const { dispatch } = useNotifications();
  const profileData = useSelector((state) => state.profile.profileData);
  const [incomingmessages, setIncomingMessages] = useState([]);
  const [message, setMessage] = useState("");
  const messagesRef = useRef(null);

  const scrollToBottom = () => {
    if (messagesRef.current) {
      messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
    }
  };
  // useEffect(() => {
  //   const channel = pusher.subscribe(`SupportChat${id}`);
  //   const handleNewMessage = (newMessage) => {
  //     if (newMessage.role === "admin") dispatch({ type: "ADD_NOTIFICATION" });
  //     setIncomingMessages((prev) => {
  //       if (
  //         !prev.some((msg) => msg.id === newMessage.id) &&
  //         !data.some((msg) => msg.id === newMessage.id)
  //       ) {
  //         return [...prev, newMessage];
  //       }
  //       return prev;
  //     });
  //   };
  //   channel.bind("chatSupport-event", handleNewMessage);
  //   return () => {
  //     pusher.unsubscribe("SupportChat");
  //   };
  // }, [data]);
  useEffect(() => {
    setIncomingMessages((prev) =>
      prev.filter(
        (incomingMsg) => !data.some((dataMsg) => dataMsg.id === incomingMsg.id)
      )
    );
    scrollToBottom();
  }, [data]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    setIsSendLoading(true);
    const { response, message: ApiMessage } = await Helper.Post({
      url: api_Routes.dashboard.tickets.addMessage,
      data: {
        message,
        ticket_support_id: id,
      },
      hasToken: true,
    });
    if (response) {
      getData();
    } else {
      setIsSendLoading(false);
      enqueueSnackbar(ApiMessage, { variant: "error" });
    }
    if (message.trim()) {
      setMessage("");
    }
  };

  return (
    <Styles>
      <div className="chat">
        <div className="messages" ref={messagesRef}>
          {/* Incoming message */}
          {data?.map((item, idx) => {
            if (item?.admin_id) {
              return (
                <div className="message-container incoming-message" key={idx}>
                  <div className="data">
                    <div className="user">
                      <img
                        src={profileData?.photo || UserPhoto}
                        alt={profileData?.name}
                      />
                    </div>
                    <div className="message">{item?.message}</div>
                  </div>
                  <div className="date">{item?.crated_at}</div>
                </div>
              );
            } else {
              return (
                <div className="message-container outcoming-message" key={idx}>
                  <div className="data">
                    <div className="user">
                      <img src={IncomingUserPhoto} />
                    </div>
                    <div className="message">{item?.message}</div>
                  </div>
                  <div className="date">{item?.crated_at}</div>
                </div>
              );
            }
          })}
          {incomingmessages &&
            incomingmessages.map((item) => {
              if (item?.role === "admin") {
                return (
                  <div
                    className="message-container incoming-message"
                    key={item?.id}
                  >
                    <div className="data">
                      <div className="user">
                        <img
                          src={profileData?.photo || UserPhoto}
                          alt={profileData?.name}
                        />
                      </div>
                      <div className="message">{item?.message}</div>
                    </div>
                    <div className="date">{item?.created_at}</div>
                  </div>
                );
              }
            })}
        </div>
        <div className="footer">
          <form onSubmit={handleSendMessage}>
            <textarea
              name="message"
              placeholder="Type a message"
              rows={5}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <Button
              type="submit"
              className="send"
              aria-label="Send message"
              disabled={
                isSendLoading || message?.length === 0 || status === "closed"
              }
            >
              {isSendLoading ? (
                <CircularProgress size={"16px"} color="#fff" />
              ) : status === "closed" ? (
                "Closed"
              ) : (
                "Send"
              )}
            </Button>
          </form>
        </div>
      </div>
    </Styles>
  );
};

export default ChatComponent;
